<template>
    <div>
        <div>
            <div style="display: flex;justify-content: center;margin-top: 20px; margin-bottom: 10px;">离校学生银行卡信息登记</div>
            <van-cell-group>
                <van-field v-model="sno" label="学号" required placeholder="请输入学号"/>
                <van-field v-model="name" label="姓名" required placeholder="请输入姓名"/>
                <van-field v-model="idNum" label="身份证号" placeholder="请输入身份证号" required/>
                <van-field v-model="random" label="验证码" required placeholder="请输入验证码">
                    <div
                            slot="button"
                            style="width: 80px; height: 20px"
                            @click="getValidCode"
                    >
                        <img
                                style="
                width: auto;
                height: auto;
                max-width: 100%;
                max-height: 100%;
              "
                                :src="valid_code_url"
                        />
                    </div>
                </van-field>

                <label
                        style="
            display: block;
            margin-left: 10px;
            margin-top: 20px;
            text-align: left;
            font-size: 12px;
          "
                >
                    注：本验证仅限于离校学生银行卡信息登记使用</label>
            </van-cell-group>
        </div>
        <div
                style="
        margin-top: 20px;
        width: 100%;
        height: 100%;
        background-color: #f4f4f5;
      "
        >
            <mobile-button style="display: flex;justify-content: center;margin: 0px 5px;" color="#ab2c31" @click="onSubmit">
                人脸识别验证
            </mobile-button>
        </div>
        <van-overlay :show="showloading" @click="showloading = false">
            <div
                    style="
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
        "
                    @click.stop
            >
                <van-loading vertical>加载中...</van-loading>
            </div>
        </van-overlay>
    </div>
</template>
<script type="text/javascript" src="https://res.wx.qq.com/open/js/jweixin-1.3.2.js"></script>
<script>
    import MobileButton from "components/mobile-button/index";
    import apiLoginPage from "api/login-page";
    import {Toast} from "vant";
    import {Dialog} from "vant";
    import {Overlay} from "vant";

    export default {
        components: {
            MobileButton,
        },
        data() {
            return {
                sno:"",
                idNum: "",
                name: "",
                random: "",
                valid_code_url: "",
                showloading: false,
            };
        },
        methods: {
            onSubmit() {
                if (this.idNum == "") {
                    Toast({
                        message: "请输入身份证号",
                        position: "top",
                        type: "fail",
                    });
                    return "";
                }
                if (this.sno == "") {
                    Toast({
                        message: "请输入学号",
                        position: "top",
                        type: "fail",
                    });
                    return "";
                }
                if (this.name == "") {
                    Toast({
                        message: "请输入姓名",
                        position: "top",
                        type: "fail",
                    });
                    return "";
                }
                if (this.random == "") {
                    Toast({
                        message: "请输入校验码",
                        position: "top",
                        type: "fail",
                    });
                    return "";
                }
                let param = {sno:this.sno,idNum: this.idNum, name: this.name, random: this.random};
                this.showloading = true;
                //通过后调起人脸识别
                apiLoginPage
                    .bankNumCheckInIdentify(param)
                    .then((res) => {
                        this.showloading = false;
                        if (res.data) {
                            let data = res.data;
                            this.wxfaceverify(data);
                            //this.wximg(data);
                        } else {
                            toastError(res);
                        }
                    })
                    .catch((err) => {
                        this.showloading = false;
                        this.getValidCode();
                    });
            },
            wxfaceverify(data) {
                const self = this;
                wx.invoke(
                    "requestWxFacePictureVerify",
                    {
                        appid: data.appId,
                        request_verify_pre_info: data.verifyInfo,
                        check_alive_type: "2",
                    },
                    function (res) {
                        if (res.err_code == 0) {
                            //跳转到验证成功页面
                            let req_param = {pid: data.pid, verifyKey: res.verify_result};
                            self.showloading = true;
                            apiLoginPage
                                .bankNumCheckInIdentifyVerify(req_param)
                                .then((res2) => {
                                    self.showloading = false;
                                    if (res2.code == 200) {
                                        let data = res2.data;
                                        let code = data.code;
                                        let name = data.name;
                                        let obj = {name:'banknum-checkin-checkin',
                                        query:{
                                            pid:code,
                                            url:name
                                        }};
                                        self.$router.push(obj);
                                    } else {
                                        toastError(res2);
                                    }
                                })
                                .catch((err2) => {
                                    self.showloading = false;
                                    self.getValidCode();
                                });
                        } else {
                            toastError(res);
                        }
                    }
                );
            },
            toastError(res) {
                Toast({
                    message: res.err_code + ":" + res.err_msg,
                    position: "top",
                    type: "fail",
                });
                this.getValidCode();
                return "";
            },
            getValidCode() {
                let d = new Date();
                let url = process.env.VUE_APP_BASE_API;
                url = url.startsWith('http') ? url : window.location.protocol + '//' + url
                let url2 = url + "/shiro/get/random/image?" + d.getTime();
                this.valid_code_url = url2;
            },
        },
        created() {
            this.showloading = true;
            let param = {
                url: location.href.split("#")[0],
            };
            //console.log(location.href.split('#')[0]);
            apiLoginPage.wexinConfig(param).then((res) => {
                this.showloading = false;
                if (res.data) {
                    wx.config({
                        debug: false,
                        beta: true,
                        appId: res.data.appId,
                        timestamp: res.data.timeStamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: ["requestWxFacePictureVerify"],
                    });
                }
            });
            this.getValidCode();
        },
    };
</script>